import React from "react";

function formatLastUploaded(timestamp) {
  if (!timestamp) return null;
  let raw = timestamp;
  if (typeof raw === "string" && /^\d{4}-\d{2}-\d{2} /.test(raw)) {
    raw = raw.replace(" ", "T");
  }
  const date = raw instanceof Date ? raw : new Date(raw);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export default function BookFileField({
  label,
  name,
  accept,
  file,
  onChange,
  existing,
  lastUploadedAt,
  required = false,
  className = "",
}) {
  const uploadedLabel = formatLastUploaded(lastUploadedAt);

  return (
    <label className={`file-upload-card ${file || existing ? "has-file" : ""} ${className}`.trim()}>
      <span className="file-upload-card-top">
        <span className="file-upload-label">
          {label}
          {required ? <span className="required-star" aria-hidden="true">*</span> : null}
        </span>
        {existing && !file ? <span className="file-upload-existing">On file</span> : null}
      </span>
      <input type="file" name={name} accept={accept} onChange={onChange} />
      <span className="file-upload-name">
        {file?.name || (existing ? "Keep current file, or choose a new one" : "No file chosen")}
      </span>
      {existing && !file ? (
        <span className="file-upload-date">
          {uploadedLabel ? `Last uploaded: ${uploadedLabel}` : "Last uploaded: date not recorded"}
        </span>
      ) : null}
    </label>
  );
}
